var path = 'app/scripts/modules/appengine/src/pipeline/stages/startServerGroup/startServerGroupStepLabel.html';
var html = "<span class=\"task-label\"> Start Server Group: {{step.context.serverGroupName}} ({{step.context.region}}) </span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;